import { add, sub } from 'date-fns'

export const SEASON_DEFAULT_END_MONTH = 6

export function getSeasonRange(seasonYear: number, endMonth: number | null): [Date, Date] {
  if (!endMonth) endMonth = SEASON_DEFAULT_END_MONTH

  const startMonth = endMonth === 12 ? 1 : endMonth + 1
  const startDay = 1

  const monthIndex = startMonth - 1
  const seasonStart = new Date(seasonYear, monthIndex, startDay)
  const seasonEnd = sub(add(seasonStart, { years: 1 }), { seconds: 1 })

  return [seasonStart, seasonEnd]
}
